module.exports = __webpack_public_path__ + "static/front-f5c09d0c9b1abef11040915233ff1652.jpg";